import React from 'react';
import { motion } from 'framer-motion';
import { User, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAdmin } from '../../contexts/AdminContext';

const ImpersonateBanner = () => {
  const { t } = useTranslation('admin');
  const { isImpersonating, impersonatedUser, stopImpersonate } = useAdmin();

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -100, opacity: 0 }}
      className="fixed top-0 left-0 right-0 z-[99999] bg-yellow-500 dark:bg-yellow-600 border-b border-yellow-600 dark:border-yellow-700 shadow-lg"
    >
      <div className="flex items-center justify-between px-6 py-3">
        <div className="flex items-center space-x-3">
          <User className="w-5 h-5 text-yellow-900 dark:text-yellow-100" />
          <p className="text-sm font-medium text-yellow-900 dark:text-yellow-100">
            {t('impersonateBanner.viewingAccountPrefix')} <span className="font-bold">{impersonatedUser.name || impersonatedUser.email}</span>{t('impersonateBanner.viewingAccountSuffix')}
          </p>
        </div>
        <button
          onClick={stopImpersonate}
          className="px-4 py-1.5 bg-yellow-600 dark:bg-yellow-700 hover:bg-yellow-700 dark:hover:bg-yellow-800 text-yellow-900 dark:text-yellow-100 rounded-lg font-medium text-sm transition-colors flex items-center space-x-2"
        >
          <span>{t('impersonateBanner.returnToOwnAccount')}</span>
          <X className="w-4 h-4" />
        </button>
      </div>
    </motion.div>
  );
};

export default ImpersonateBanner;

